export const textFieldFilteration = (value, type) => {
  let filteredValue = '';

  if (type === 'text') {
    filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
  } else if (type === 'number') {
    filteredValue = value.replace(/[^0-9]/g, '');
    if (filteredValue.length > 11) {
      filteredValue = filteredValue.slice(0, 11);
    }
  } else if (type === 'alphanumeric') {
    filteredValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
  } else if (type === 'email') {
    filteredValue = value.replace(/[^a-zA-Z0-9@._-]/g, '');
  } else if (type === 'date') {
    filteredValue = value.replace(/[^0-9\/\-\s]/g, '');
  } else if (type === 'alphanumericWithSpecialChars') {
    filteredValue = value.replace(/[^a-zA-Z0-9\s,.\?!@#$%^&*()+=\-_:;\"'`{}[\]]/g, '');
  }

  return filteredValue;
};


export function validateEmail(email: string) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
